<template>
<span>{{ vulnerableTitle }}</span>  
</template>
<script>
export default {
  props: {
    vulnerable: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String
    }
  },

  computed: {
    vulnerableTitle() {
      switch(this.type) {
        case 'vulnerability': return this.vulnerable.cvid
        case 'cwe': return 'CWE-' + this.vulnerable.number
      }
    }
  }
}
</script>